export function upperFirst(str: string) {
  return `${str[0].toUpperCase()}${str.substring(1)}`;
}

export function parseString(str: number | string): string {
  return typeof str === 'string' ? str : str.toString();
}

export function parseNumber(str: number | string): number {
  return typeof str === 'string' ? parseInt(str, 10) : str;
}

export function toOrdinal(num: number | string): string {
  const n = typeof num === 'string' ? parseInt(num, 10) : num;
  const lastDigit = n % 10;
  const lastTwoDigits = n % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return `${n}th`;
  }

  switch (lastDigit) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}
